import { _unsubscribeDialogActionFailedText } from 'owa-locstrings/lib/strings/_unsubscribedialogactionfailedtext.locstring.json';
import { unsubscribeDialogActionFailed } from 'owa-locstrings/lib/strings/unsubscribedialogactionfailed.locstring.json';
import loc from 'owa-localize';
import { onUnsubscribeFromBrand } from '../actions/internalActions';
import { onAfterUnsubscribe, UnsubscribeResponseType } from 'owa-brands-subscription';
import { confirm } from 'owa-confirm-dialog';

import { orchestrator } from 'satcheljs';

export default orchestrator(onAfterUnsubscribe, actionMessage => {
    if (actionMessage.unsubscribeSourceType !== 'SubscriptionHub') {
        return;
    }

    if (actionMessage.responseType === UnsubscribeResponseType.Success) {
        onUnsubscribeFromBrand(actionMessage.smtpIdentifier);
    } else {
        confirm(
            loc(unsubscribeDialogActionFailed),
            loc(_unsubscribeDialogActionFailedText),
            false,
            {
                hideCancelButton: true,
            }
        );
    }
});
